import { getFormValue } from '../utils'

export const prepareValuesForPreview = (eventType, formValues) => ({
  description: getFormValue(eventType.description, formValues.description?.html)
})
